(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
    #controller = null;
    #timer = null;

    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-results]');
      this.input?.addEventListener('input', () => this.#onInput());
      this.closest('dialog')?.addEventListener('close', () => this.#reset());
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }

    #onInput() {
      clearTimeout(this.#timer);
      const term = this.input.value.trim();
      if (this.dataset.enabled !== 'true') return;
      if (term.length < 2) {
        this.results.innerHTML = '';
        return;
      }
      this.#timer = setTimeout(() => this.#fetch(term), 220);
    }

    async #fetch(term) {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const url = new URL(window.FBC.routes.predictiveSearch, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('section_id', 'predictive-search');
      url.searchParams.set('resources[type]', 'product,collection,page,query');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
      try {
        const response = await fetch(url, { signal: this.#controller.signal });
        if (!response.ok) throw new Error(String(response.status));
        const html = await response.text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-results]');
        this.results.innerHTML = fresh ? fresh.outerHTML : '';
      } catch (error) {
        if (error.name !== 'AbortError') this.results.innerHTML = '';
      }
    }

    #reset() {
      this.#controller?.abort();
      this.results.innerHTML = '';
    }
  }

  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-search-open]');
    if (!opener || !document.getElementById('SearchModal')) return;
    event.preventDefault();
    window.FBC.openDialog('SearchModal', opener);
  });
  } catch(e) { console.error(e); }
})();

})();
